import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PaceWattsCalculator"] */ "/opt/buildhome/repo/src/components/tools/pace-watts-calculator.tsx");
